<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card outlined>
                    <v-card-title class="text-subtitle-1 white--text" style="background-color: #1565c0;" dark>
                        Pendientes
                    </v-card-title>
                    <v-card-text class="px-1 mt-5">
                        <v-expansion-panels accordion>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Actividades pendientes</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row dense>
                                        <template v-if="actividadesFam.length < 1">
                                            <v-col cols="12">
                                                <v-card outlined>
                                                    <v-card-text style="height: 80px;"
                                                        class="d-flex justify-center align-center">
                                                        Sin actividades pendientes
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </template>
                                        <template v-else>
                                            <v-col cols="12" v-for="item in actividadesFam" :key="item.id">
                                                <v-card color="light-gray">
                                                    <v-card-text>
                                                        <v-row dense>
                                                            <v-col cols="12">
                                                                <v-row dense>
                                                                    <v-col cols="12" class="primary--text">
                                                                        <v-icon icon left x-small>fas fa-list</v-icon>
                                                                        {{ item.desc_tipo_actividad }}
                                                                    </v-col>
                                                                    <v-col cols="12" class="py-0  d-flex  text-caption">
                                                                        {{ item.nombre_persona + ' ' + item.ape1_persona
                                                                        }}
                                                                    </v-col>
                                                                    <v-col cols="12" class="py-0  d-flex caption">
                                                                        {{ item.desc_curso }}
                                                                    </v-col>
                                                                    <v-col cols="12"
                                                                        class="py-0  d-flex justify-end gap-10px">
                                                                        <v-chip label x-small>
                                                                            Vence : {{ item.fecha_actividad |
                                                                                filtroFecha }}
                                                                        </v-chip>
                                                                        <v-chip label x-small>
                                                                            {{ item.hora_fin_actividad |
                                                                                filtroFormatoHora
                                                                            }}
                                                                        </v-chip>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-col>
                                                            <v-col cols="12" class="d-flex justify-end align-center">
                                                                <v-chip x-small label>
                                                                    <v-icon left x-small>
                                                                        fas fa-info
                                                                    </v-icon>
                                                                    {{ item.desc_estado_alumno }}
                                                                </v-chip>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Evaluaciones pendientes</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row dense>
                                        <template v-if="evaluacionesFam.length < 1">
                                            <v-col cols="12">
                                                <v-card outlined>
                                                    <v-card-text style="height: 80px;"
                                                        class="d-flex justify-center align-center">
                                                        Sin evaluaciones pendientes
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </template>
                                        <template v-else>
                                            <v-col cols="12" v-for="item in evaluacionesFam" :key="item.id">
                                                <v-card color="light-gray">
                                                    <v-card-text>
                                                        <v-row dense>
                                                            <v-col cols="12">
                                                                <v-row dense>
                                                                    <v-col cols="12" class="primary--text">
                                                                        <v-icon icon left x-small>fas fa-list</v-icon>
                                                                        {{ item.desc_tipo }}
                                                                    </v-col>
                                                                    <v-col cols="12" class="py-0  d-flex  text-caption">
                                                                        Alumno : {{ item.nombre_persona + ' ' +
                                                                            item.ape1_persona
                                                                        }}
                                                                    </v-col>
                                                                    <v-col cols="12" class="py-0 d-flex text-caption">
                                                                        Docente : {{ item.nombre_profesor + ' ' +
                                                                            item.apellido_profesor }}
                                                                    </v-col>
                                                                    <v-col cols="12" class="py-0  d-flex caption">
                                                                        {{ item.desc_curso }}
                                                                    </v-col>
                                                                    <v-col cols="12"
                                                                        class="py-0  d-flex justify-end gap-10px">
                                                                        <v-chip label x-small>
                                                                            Fecha : {{ item.fecha_actividad |
                                                                                filtroFecha }}
                                                                        </v-chip>
                                                                        <v-chip label x-small>
                                                                            Inicio : {{ item.hora_inicio |
                                                                                filtroFormatoHora
                                                                            }}
                                                                        </v-chip>
                                                                        <v-chip label x-small>
                                                                            Fin :{{
                                                                                item.hora_fin | filtroFormatoHora
                                                                            }}
                                                                        </v-chip>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-col>
                                                            <v-col cols="12" class="d-flex justify-end align-center">
                                                                <v-chip x-small label>
                                                                    <v-icon left x-small>
                                                                        fas fa-info
                                                                    </v-icon>
                                                                    {{ item.desc_estado }}
                                                                </v-chip>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </template>


                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                                <v-expansion-panel-header>Somos habiles pendientes</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row dense>
                                        <template v-if="somoshabilesFam.length < 1">
                                            <v-col cols="12">
                                                <v-card outlined>
                                                    <v-card-text style="height: 80px;"
                                                        class="d-flex justify-center align-center">
                                                        Sin evaluaciones pendientes
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </template>
                                        <template v-else>
                                            <v-col cols="12" v-for="item in somoshabilesFam" :key="item.id_clase">
                                                <v-card color="light-gray">
                                                    <v-card-text>
                                                        <v-row dense>
                                                            <v-col cols="8">
                                                                <v-row dense>
                                                                    <v-col cols="12"
                                                                        class="font-weight-black primary--text">
                                                                        <v-icon icon left x-small>fas fa-list</v-icon>
                                                                        {{ item.tipo_examen }}
                                                                    </v-col>
                                                                    <v-col cols="12" class="d-flex caption">
                                                                        {{ item.nombre_persona + ' ' + item.ape1_persona
                                                                        }}
                                                                    </v-col>
                                                                    <v-col cols="12">
                                                                        <v-chip label x-small>
                                                                            Dia : {{ item.fecha_creacion |
                                                                                filtroFecha }}
                                                                        </v-chip>

                                                                    </v-col>
                                                                </v-row>

                                                            </v-col>

                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </template>


                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from "@/helpers/axios"
// eslint-disable-next-line no-unused-vars
import { mapMutations, mapGetters, mapActions } from 'vuex';
export default {


    data: () => ({
        datoLogin: sessionStorage,
        familiarData: [],
        actividadesFam: [],
        evaluacionesFam: [],
        somoshabilesFam: []
    }),
    mounted() {
        this.loadMain();

    },
    methods: {
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ...mapActions('login', ['parametroComponente']),

        async loadMain() {
            // consulta los alumnos que tiene a disposicion el padre de familia
            try {
                let response = await axios.post(`/notification/persona/getFamiliarNotif/${this.datoLogin.id}`)
                this.familiarData = response.data
                this.AcvitidadesFam();
                this.EvaluacionesFam();
                this.getSomoshabilesPendfam();
            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },

        async AcvitidadesFam() {
            try {

                const arraychildrens = this.familiarData.map(item => item.id);
                const params = {
                    childrens: arraychildrens
                }
                let response = await axios.post("/notification/persona/getActivFam/", params)
                this.actividadesFam = response.data
            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },

        async EvaluacionesFam() {
            try {
                const arraychildrens = this.familiarData.map(item => item.id);
                const params = {
                    childrens: arraychildrens
                }
                let response = await axios.post("/notification/persona/getEvalFam/", params)
                this.evaluacionesFam = response.data
            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },

        async getSomoshabilesPendfam() {
            try {
                const arraychildrens = this.familiarData.map(item => item.id);
                const params = {
                    childrens: arraychildrens
                }
                let response = await axios.post("/notification/persona/getsomosHab/", params)
                this.somoshabilesFam = response.data
            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        }
    }
}
</script>